module.exports = __webpack_public_path__ + "img/trofeu.3ee3ac6f.png";